// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: 'https://roadmap-be.onrender.com',
  firebaseConfig: {
    apiKey: 'AIzaSyAIH2SRVgA38uxk5CDsOARjlXwqxdOzRlk',
    authDomain: 'roadmap-platform.firebaseapp.com',
    projectId: 'roadmap-platform',
    storageBucket: 'roadmap-platform.appspot.com',
    messagingSenderId: '48883245735',
    appId: '1:48883245735:web:478f9b08622eb340cef182',
    measurementId: 'G-5915Z20ELZ',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
